import { useState, useRef, useEffect } from 'react';
import '../housestyle.css';
import './Home.css';
import api from '../API/Api';


function IPBar() {
  const [toastVisible, setToastVisible] = useState(false);
  const timerRef = useRef(null);

  function copyIP() {
    navigator.clipboard.writeText('play.simplemcnetwork.net').catch(() => { });
    setToastVisible(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setToastVisible(false), 1800);
  }

  return (
    <>
      <div className="home-ip-bar">
        <div className="home-ip-item">
          <span className="home-ip-label">IP</span>
          <span className="home-ip-value">play.simplemcnetwork.net</span>
          <button className="home-ip-copy" onClick={copyIP}>Copy</button>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Version</span>
          <span className="home-ip-value">1.21+</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Status</span>
          <span className="home-ip-value home-ip-value--development">● in development</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Mode</span>
          <span className="home-ip-value" style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Java</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Support cracked?</span>
          <span className="home-ip-value" style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Yes</span>
        </div>
      </div>

      <div className={`home-copied-toast${toastVisible ? ' show' : ''}`}>
        IP Copied!
      </div>
    </>
  );
}

function StatCard({ icon, value, label }) {
  return (
    <div className="home-stat-card">
      <span className="home-stat-icon">{icon}</span>
      <div>
        <div className="home-stat-val">{value}</div>
        <div className="home-stat-lbl">{label}</div>
      </div>
    </div>
  );
}

function FeatureCard({ icon, title, desc, barClass }) {
  return (
    <div className="home-feat-card">
      <div className={`home-feat-bar ${barClass}`} />
      <span className="home-feat-icon">{icon}</span>
      <h3>{title}</h3>
      <p>{desc}</p>
    </div>
  );
}

function Step({ num, title, children }) {
  return (
    <div className="home-step">
      <div className="home-step-num">{num}</div>
      <h4>{title}</h4>
      <p>{children}</p>
    </div>
  );
}

const serverinfo = [
  { icon: '⛏', value: 'Season 1', label: 'Current Season' },
  { icon: '🗺', value: '10K x 10K', label: 'EXPANDABLE World Border' },
  { icon: '⚔️', value: 'Custom', label: 'Weapons & Mobs and Recipes' },
  { icon: '🏆', value: 'Daily / Weekly', label: 'Events & Supply Drops' },
];

const features = [
  {
    icon: '⚔️',
    title: 'Custom Weapons',
    desc: 'New weapons, armour, tools and other items - crafted in-game with new drops from various sources.',
    barClass: 'home-feat-bar--red',
  },
  {
    icon: '🐉',
    title: 'Custom Mobs',
    desc: "Unique bosses and mob variants with tiered drops. Explore the world and find what's lurking.",
    barClass: 'home-feat-bar--blue',
  },
  {
    icon: '📦',
    title: 'Supply Drops',
    desc: 'Random supply crates scattered across the map. Loot them before someone else does.',
    barClass: 'home-feat-bar--green',
  },
  {
    icon: '🎉',
    title: 'Events',
    desc: 'Regular seasonal events and competitions with exclusive rewards and community engagement.',
    barClass: 'home-feat-bar--gold',
  },
  {
    icon: '👥',
    title: 'Fun Community',
    desc: 'Active player base with regular polls, staff interaction, and a welcoming environment for all.',
    barClass: 'home-feat-bar--purple',
  },
  {
    icon: '🛡️',
    title: 'Good Anticheat',
    desc: 'Advanced cheat detection keeps the playing field fair for everyone.',
    barClass: 'home-feat-bar--blue',
  },
  {
    icon: '🔑',
    title: 'Cracked Supported',
    desc: 'Play with or without a premium Minecraft account. Everyone welcome.',
    barClass: 'home-feat-bar--green',
  },
  {
    icon: '🗺️',
    title: 'New POIs',
    desc: 'Explore unique locations with interesting stories and challenges.',
    barClass: 'home-feat-bar--gold',
  }
];

export default function HomePage() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    api('trackvisit').then(res => {
      if (res.isSuccess) setVisits(res.data?.visits ?? null);
    });
  }, []);
  return (
    <div style={{ paddingBottom: '4rem' }}>

      <div className="home-hero">
        <video autoPlay muted loop playsInline src='https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Trailer.mp4'>
        </video>
        <div className="home-hero-overlay" />
        <div className="home-hero-logo">
          <div className="home-hero-logo-text">
            Simple<em>MC</em>
          </div>
          <div className="home-hero-logo-sub">Season 1 | Survival SMP</div>
          <div className="home-hero-logo-text-medium">IN DEVELOPMENT</div>
        </div>
        <div className="home-hero-video-label">Website Visits: {visits}</div>
      </div>

      <IPBar />

      <div className="container" style={{ paddingTop: '3.5rem' }}>
        <div className="home-about-grid">
          <div className="home-about-main">
            <div className="home-eyebrow">Season 1</div>
            <h2>A Survival SMP <span>completely reinvented.</span></h2>
            <p>
              Experience Minecraft like never before. Face entirely new mobs, discover custom biomes,
              and encounter bosses that will change how you play. Every corner of the map holds surprises
              brand new creatures, mechanics, and challenges await. Build, compete, and survive in a world
              designed to deliver a fresh adventure beyond vanilla Minecraft.
            </p>
            <div className="home-about-btns">
              <button className="btn btn-primary">Join Now</button>
              <button className="btn btn-secondary"
                onClick={() => window.open('https://discord.com/invite/simplemc', '_blank')}>
                Discord
              </button>
            </div>
          </div>

          <div className="home-stat-stack">
            {serverinfo.map((s, i) => (
              <StatCard key={i} icon={s.icon} value={s.value} label={s.label} />
            ))}
          </div>
        </div>

        <div className="section-label" style={{ marginBottom: '1.25rem' }}>
          <span className="sl-text">New Experience</span>
        </div>

        <div className="home-features-grid">
          {features.map((f, i) => (
            <FeatureCard
              key={i}
              icon={f.icon}
              title={f.title}
              desc={f.desc}
              barClass={f.barClass}
            />
          ))}
        </div>

        <div className="section-label" style={{ marginBottom: '1.25rem' }}>
          <span className="sl-text">How to join</span>
        </div>

        <div className="home-join-card">
          <div className="home-steps">
            <Step num="1" title="Open Minecraft">
              Launch Java Edition 1.21+ or higher on your PC.
            </Step>
            <Step num="2" title="Add Server">
              Go to Multiplayer → Add Server and give it a name.
            </Step>
            <Step num="3" title="Enter IP">
              Server address:{' '}
              <span className="home-step-ip">play.simplemcnetwork.net</span>
            </Step>
            <Step num="4" title="Join & Play">
              Hit connect and spawn in. Prepare for the unexpected.
            </Step>
          </div>
        </div>
      </div>
    </div>
  );
}